import * as React from 'react';
import { FC } from 'react';
import {
    EditProps,
    FormWithRedirect,
    SaveButton,
    DeleteButton,
    TextInput,
    useTranslate,
    AutocompleteInput,
    SelectInput,
    required,
    ReferenceInput,
    // DateTimeInput,
    // NumberInput
} from 'react-admin';
import {
    makeStyles,
    createStyles,
    Theme,
    Typography,
    Box,
    Toolbar,
    Grid
} from '@material-ui/core';
import { CurrencyFormatInput } from '../utils/formatters';
import { useFormState } from 'react-final-form';
import TransactionTypes from './CollectionsTypes'
import { removeTimezone } from '../utils/time';
import { DateTimeInput } from '../components/DatePickers';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(2),
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
    }),
);

const FinancingInput = (props: any) => {
    const { values } = useFormState();

    if (values.merchant_id) {
        return <ReferenceInput
            source="financing_id"
            reference="Financing"
            filter={{ merchant_id: values.merchant_id }}
            sort={{ field: 'id', order: 'DESC' }}
            {...props}
        >
            <SelectInput optionText="id" optionValue="id" validate={[required()]} {...props} />
        </ReferenceInput>
    } else {
        return <></>
    }
}

const TransactionEdit: FC<EditProps> = props => {
    const classes = useStyles()
    const translate = useTranslate()
    const types = TransactionTypes()

    return <FormWithRedirect
        warnWhenUnsavedChanges

        {...props}
        render={formProps => (
            // here starts the custom form layout
            <Box>
                <Typography variant="h6">{translate("resources.common.fieldGroups.basicInfo")}</Typography>
                <Grid container className={classes.root} spacing={2}>
                    <Grid item xs={12} sm={3}>
                        <DateTimeInput
                            source="timestamp"
                            fullWidth
                            validate={[required()]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <ReferenceInput
                            source="merchant_id"
                            reference="Merchant"
                            sort={{ field: 'name', order: 'ASC' }}
                            perPage={10}
                            filterToQuery={name => ({ name })}
                        >
                            <AutocompleteInput optionText="name" fullWidth resettable validate={[required()]} />
                        </ReferenceInput>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FinancingInput fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <SelectInput source="type" choices={types} fullWidth validate={[required()]} />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextInput
                            source="value"
                            // initialValue={0}
                            format={(v: number) => v / 100}
                            parse={(v: string) => Math.floor(parseFloat(v) * 100)}
                            InputProps={{
                                inputComponent: CurrencyFormatInput,
                            }}
                            validate={[required()]}
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12} sm={3} >
                        <TextInput
                            source="transfer_to_merchant"
                            format={(v: number) => v / 100}
                            parse={(v: string) => Math.floor(parseFloat(v) * 100)}
                            // initialValue={0}
                            InputProps={{
                                inputComponent: CurrencyFormatInput,
                            }}
                            validate={[required()]}
                            fullWidth
                        />
                    </Grid>
                </Grid>
                <Toolbar>
                    <Box display="flex" justifyContent="space-between" width="100%">
                        <SaveButton
                            saving={formProps.saving}
                            handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                            transform={data => {
                                data.timestamp = removeTimezone(new Date(data.timestamp))
                                // console.log(data)
                                return { ...data }
                            }}

                        />
                        <DeleteButton record={formProps.record} />
                    </Box>
                </Toolbar>
            </Box>
        )}
    />
}

export default TransactionEdit;
